export default __webpack_public_path__ + "9d19d9e898ad93779c498a439cf0cab6.svg";